<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead v-if="!loadingDocuments && returnedDocuments.length">
                    <tr>
                        <th>{{$t('dashboard.documents.returns_table.header.document')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody v-if="loadingDocuments" :key="'loading'">
                    <tr  class="table--loading">
                        <td colspan="5">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('dashboard.documents.table.loading')}}</div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!loadingDocuments && !returnedDocuments.length" :key="'no-documents'">
                    <tr  class="table--empty">
                        <td colspan="5">
                            <div class="text-center">{{$t('dashboard.documents.table.no_documents')}}</div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!loadingDocuments && returnedDocuments.length">
                    <tr v-for="(document, index) in returnedDocuments" :key="document.name + index">
                        <td>{{ document.name }}</td>
                        <td>
                            <span v-tooltip.bottom="documentTooltipContent(document)" class="table__icon icons icon-info"></span>
                        </td>
                        <td><span @click="downloadDocument(document)" v-tooltip.bottom="$t('dashboard.documents.table.download')" class="table__icon icons icon-cloud-download"></span></td>
                        <td><span @click="showDeleteDocumentModal(document)" v-tooltip.bottom="$t('dashboard.documents.table.delete')" class="table__icon icons icon-trash"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import { saveFile } from '@/helpers';
    import ReturnedDocument from '@/models/ReturnedDocument';

    import { GET_DOCUMENTS } from '@/store/modules/documents';

    @Component
    export default class ReturnedDocumentsTable extends Vue {
        name = 'returned-documents-table';

        @Prop()
        originalDocument;

        loadingDocuments = false;
        returnedDocuments = [];

        mounted() {
            this.fetchReturnedDocuments();
        }

        fetchReturnedDocuments() {
            this.loadingDocuments = true;
            const ReturnedDocuments = ReturnedDocument.makeModel(`/trajectories/${this.trajectory.id}/files/${this.originalDocument.id}/returns`);
            ReturnedDocuments.collection()
                .then(({items, meta}) => {
                    this.returnedDocuments = items;
                })
                .catch(err => {
                    let errors = err.response && err.response.data ? err.response.data : err;
                    this.$notify.error(this.$t('notify.returned_document.fetch_error'));
                    this.$modal.hide(this.name);
                })
                .then(() => this.loadingDocuments = false);
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        documentTooltipContent(document) {
            return this.$t('dashboard.documents.returns_table.document_info', { sender: document.uploader.name, date: document.date});
        }

        downloadDocument(document) {
            const url = `trajectories/${this.trajectory.id}/files/${this.originalDocument.id}/returns/${document.id}/download`;
            return this.axios.get(url, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, document.name, document.mime),
                    err => this.$notify.error(this.$t('notify.download_error')));
        }

        showDeleteDocumentModal(document) {
            const content = {
                title: this.$t('modals.delete_document.title'),
                message: this.$t('modals.delete_document.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteDocument, document});
        }

        deleteDocument({document}) {
            document.remove()
                .then(() => {
                    this.fetchReturnedDocuments();
                    this.$notify.success(this.$t('notify.document.delete_success'));
                    this.$store.dispatch(GET_DOCUMENTS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.document.delete_error')));
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/ReturnedDocumentsTable.vue